module.exports = __webpack_public_path__ + "media/images/author/author-8-b262bda7da990cc6e5d6293feafe09e7.jpg";